export default __webpack_public_path__ + "media/zurb/img/home/mcafee-logo-7c5632045556f8bf5009fd91ed51b89c.png";